/* Filters an array by removing the element at index */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
const arrayWithoutElementAtIndex = function (arr: any, index: number) {
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	return arr.filter(function (_: any, arrIndex: number) {
		return index !== arrIndex;
	});
};

export { arrayWithoutElementAtIndex };
